import { Link } from "react-router-dom";
import { routes } from "constants/index";
import { useSchoolLocal } from "../useSchoolLocal";

type ConnectWithUsButtonProps = {
  variant?: "primary" | "inverted";
  className?: string;
};

const variantClassNames = {
  primary: "bg-[#4242CE] text-white hover:bg-[#4242CE]/90",
  inverted: "bg-white text-[#4242CE] hover:bg-white/90",
};

export const ConnectWithUsButton = ({
  variant = "primary",
  className = "",
}: ConnectWithUsButtonProps) => {
  const { t } = useSchoolLocal();

  return (
    <Link
      to={routes.schoolPartnership}
      className={`inline-flex items-center justify-center whitespace-nowrap rounded-xl px-6 py-3 text-[16px] font-medium transition-colors duration-200 ${variantClassNames[variant]} ${className}`}
    >
      {t("buttons.connectWithUs")}
    </Link>
  );
};
